import { type ReactElement } from 'react';
import { SettingsPageShell } from '@/components/settings/SettingsPageShell';

export default function SettingsTab(): ReactElement {
  return <SettingsPageShell context="organization" />;
}
